import React from 'react';
import __ from 'lodash';
 
class DropdownProfilCbt extends React.Component{
    render(){
        return (
            this.props.profil.map((val) => 
                <option key={val.idProfilCbt} value={val.idProfilCbt}>{val.namaProfilCbt}</option>
            )            
        )
    }
}

export default DropdownProfilCbt;